import React, { useEffect } from "react";

export default function Modal({ open, onClose, title, children, testId, wide = false, xwide = false }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  const widthClass = xwide ? "max-w-6xl" : wide ? "max-w-3xl" : "max-w-lg";
  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 backdrop-blur-sm p-4 sm:py-10 overflow-y-auto overscroll-contain"
      onClick={onClose}
      data-testid={testId}
    >
      <div
        className={`bg-white border border-[var(--border)] w-full ${widthClass}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-b border-[var(--border)] px-5 py-3 flex items-center justify-between">
          <h3 className="font-display text-xl font-bold tracking-tight">{title}</h3>
          <button
            onClick={onClose}
            className="text-[var(--text-secondary)] hover:text-black w-8 h-8 flex items-center justify-center"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
